import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { ISanctionedGroupMySuffix } from 'src/app/shared/model/sanctioned-group-my-suffix.model';
import { SanctionedGroupMySuffixService } from './sanctioned-group-my-suffix.service';

import { ConfirmationModelService } from 'src/app/shared/confirmation-modal/confirmation-model.service';
import { FutureDataType } from 'src/app/shared/model/future_data_type.model'
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

@Component({
    selector: 'jhi-sanctioned-group-my-suffix-delete-dialog',
    templateUrl: './sanctioned-group-my-suffix-delete-dialog.component.html'
})
export class SanctionedGroupMySuffixDeleteDialogComponent {
    sanctionedGroup: ISanctionedGroupMySuffix;
    futureStatus: boolean = false;
    isConfirmed: boolean = false;
    
    constructor(
        private sanctionedGroupService: SanctionedGroupMySuffixService,
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager,
        private futureRecordService: ConfirmationModelService,
        private languageChangeService: LanguageChangeService,
        private activatedRoute: ActivatedRoute
    ) {
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    setFutureStatus(futureStatus) {
        this.futureStatus = futureStatus;
    }

    confirmDelete(id: number) {
        this.isConfirmed = true;
        if (this.futureStatus) {
            this.updateExistedFutureRecordStatus(id);
        }
        this.sanctionedGroupService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'sanctionedGroupListModification',
                content: 'Deleted an sanctionedGroup'
            });
            this.activeModal.dismiss(true);
        });
    }

    updateExistedFutureRecordStatus(id: number) {
        this.futureRecordService.updateExistedFutureRecordStatus({
            masterId: this.sanctionedGroup.id,
            futureDataType: FutureDataType.SANCTIONED_GROUP.valueOf(),
            fromEffectiveDateFormatted: this.sanctionedGroup.fromEffectiveDate,
            masterStatus : this.sanctionedGroup.activeStatus == 'ACTIVE' ? 'IN_ACTIVE' : 'ACTIVE',
        }).subscribe(response => {
            console.log(response.body);
        });
    }
}

@Component({
    selector: 'jhi-sanctioned-group-my-suffix-delete-popup',
    template: ''
})
export class SanctionedGroupMySuffixDeletePopupComponent implements OnInit, OnDestroy {
    private ngbModalRef: NgbModalRef;

    constructor(private activatedRoute: ActivatedRoute, private router: Router, private modalService: NgbModal) {}

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ sanctionedGroup }) => {
            setTimeout(() => {
                this.ngbModalRef = this.modalService.open(SanctionedGroupMySuffixDeleteDialogComponent as Component, {
                    size: 'lg',
                    backdrop: 'static'
                });
                this.ngbModalRef.componentInstance.sanctionedGroup = sanctionedGroup;
                this.ngbModalRef.result.then(
                    result => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/sanctioned-group']));
                        this.ngbModalRef = null;
                    },
                    reason => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/sanctioned-group']));
                        this.ngbModalRef = null;
                    }
                );
            }, 0);
        });
    }

    ngOnDestroy() {
        this.ngbModalRef = null;
    }
}
